// Fallback temperature range (°F) for wake/sleep setpoints, used only when the climate
// entity's own min_temp/max_temp attributes are unavailable. Matches the HA input_number
// clamp (68–74) so the app never offers a value HA will silently reject.
export const CLIMATE_MIN_TEMP = 68;
export const CLIMATE_MAX_TEMP = 74;

export type ScheduleDayType = 'weekday' | 'weekend';

// The per-day-type schedule fields (wake/sleep time, temp, mode).
export interface IHVACScheduleProfile {
  wakeTime: string;
  sleepTime: string;
  wakeTemp: number;
  sleepTemp: number;
  wakeMode: string;
  sleepMode: string;
}

export interface IHVACDeviceBase {
  deviceId: string;
  deviceName: string;
  currentTemp?: number;
  currentMode: string;
  setToTemp?: number;
  isUnavailable: boolean;
  hvacAction: string | undefined;
}

export interface IHVACDeviceControl extends IHVACDeviceBase {
  availableModes: string[];
}

export interface IHVACDeviceConfig extends IHVACDeviceBase {
  // Flat fields are the weekday / default profile (kept flat for back-compat).
  wakeTime: string;
  sleepTime: string;
  wakeTemp: number;
  sleepTemp: number;
  autoset: boolean;
  wakeMode: string;
  sleepMode: string;
  // Weekday/weekend split (VI-275). Populated only when helpers exist.
  weekend?: IHVACScheduleProfile;
  scheduleSplit?: boolean;
  activeSchedule?: ScheduleDayType;
}
